import { CloseOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Modal, Space } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { http } from '@services/http'

import BpInfo from '../ViewSalesModal/bpInfo'
import DownPaymentsInfo from '../ViewSalesModal/downPaymentsInfo'
import ImageTab from '../ViewSalesModal/imageInfo'
import ProductionInViewSales from '../ViewSalesModal/Production'
import SalesInfo from '../ViewSalesModal/salesInfo'



const ViewSalesModal = ({
	visible,
	data,
	onClose,
	ship = false,
	incoming = false,
	isShowStartProduction = false,
		isShowProfit = false,
	refetch,
}) => {
	const fetchOneSale = async ({ queryKey }) => {
		const [_, docEntry] = queryKey
		try {
			const url = `api/sales/sotuv-buyurtmasi?docEntry=${docEntry}`
			const { data } = await http.get(url)
			return data.data[0]
		} catch (error) {
			console.log(error)
		}
	}

	const {
		data: salesData = {
			documentLines: [],
		},
		isLoading,
	} = useQuery({
		queryKey: ['oneSalesOrder', data?.docEntry, visible],
		queryFn: fetchOneSale,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		enabled: !!data?.docEntry,
	})
	const renderContent = () => {
		switch (activeTab) {
			case 'tab1':
				return (
					<SalesInfo
						data={salesData}
						onClose={onCloseModal}
						ship={ship}
						incoming={incoming}
						refetch={refetch}
						isShowStartProduction={isShowStartProduction}
							isShowProfit={isShowProfit}
					/>
				)
			case 'tab2':
				return <BpInfo cardCode={salesData?.cardCode} />
			case 'tab3':
				return <ProductionInViewSales docEntry={data?.docEntry} />
			case 'tab4':
				return (
					<DownPaymentsInfo
						docEntry={data?.docEntry}
						data={salesData}
					/>
				)
			case 'tab5':
				return <ImageTab data={salesData} />

			default:
				return null
		}
	}
	const { t } = useTranslation()

	const [activeTab, setActiveTab] = useState('tab1')

	const onCloseModal = () => {
		onClose()
		setActiveTab('tab1')
	}

	if (!data) return null

	return (
		<Modal
			title={
				<h1 className="font-nunito text-xl font-extrabold text-[#000000]">
					{t('order')} № {salesData?.docNum}
				</h1>
			}
			open={visible}
			onCancel={onCloseModal}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="90%"
		>
			<Space style={{ marginBottom: 16 }} className="mt-5">
				<button
					className={`${
						activeTab === 'tab1'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold `}
					onClick={() => setActiveTab('tab1')}
				>
					{t('salesInfo')}
				</button>
				<button
					className={`${
						activeTab === 'tab2'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold ml-3`}
					onClick={() => setActiveTab('tab2')}
				>
					{t('bpInfo')}
				</button>
				<button
					className={`${
						activeTab === 'tab3'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold ml-3`}
					onClick={() => setActiveTab('tab3')}
				>
					{t('production')}
				</button>
				<button
					className={`${
						activeTab === 'tab4'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold ml-3`}
					onClick={() => setActiveTab('tab4')}
				>
					{t('payments')}
				</button>
				<button
					className={`${
						activeTab === 'tab5'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold ml-3`}
					onClick={() => setActiveTab('tab5')}
				>
					{t('drawingPhoto')}
				</button>
			</Space>
			<div className="mt-5">{renderContent()}</div>
		</Modal>
	)
}

export default ViewSalesModal
